import { SliderMarks } from "antd/lib/slider";
import { Colors, Fonts } from "../utils/constants";
import { blueBg, flexColumn, fullHeight, spaceEvenly } from "./CommonStyles";

// Qoute view
export const stepsContainer = {
  ...blueBg,
  ...flexColumn,
  display: "flex",
  alignItems: "center",
  overflowY: "auto" as "auto",
};

export const stepperContainer = {
  width: "70%",
  height: "15%",
  marginTop: 30,
};

const bttns = {
  width: 206,
  height: 56,
  fontFamily: Fonts.sspBold,
  fontSize: 16,
};

export const nexBttn = {
  ...bttns,
  backgroundColor: Colors.yellow,
  color: Colors.blue,
  borderWidth: 0,
};

export const backBttn = {
  ...bttns,
  backgroundColor: "transparent",
  color: "white",
  borderColor: "white",
};

export const disabledBttn = {
  ...bttns,
  backgroundColor: "#F1DA9A",
  color: Colors.lightGrey,
};

// First step

export const advanceMarks: SliderMarks = {
  0: {
    label: "",
  },
  25: {
    style: {
      color: "#fff",
      fontSize: 16,
      fontFamily: Fonts.sspBold,
      marginTop: -45,
    },
    label: "25%",
  },
  100: {
    style: {
      color: "#fff",
      fontSize: 16,
      fontFamily: Fonts.sspBold,
      marginTop: -45,
    },
    label: "100%",
  },
};

export const StyleLabelSlider = {
  color: "#fff",
  fontSize: 16,
  fontFamily: Fonts.sspBold,
  marginTop: -45,
};

export const firstStepContainer = {
  ...flexColumn,
  ...fullHeight,
  padding: 30,
  width: "90%",
};

export const FormularioContainer = {
  ...flexColumn,
  ...fullHeight,
  padding: 30,
  width: "90%",
};
export const TitleFormularioContainer = {
  fontFamily: Fonts.sspBold,
  fontSize: 34,
  color: "white",
  marginBottom: "3vh",
};

export const ThirdStepContainer = {
  ...flexColumn,
  ...fullHeight,
  padding: 30,
  width: "90%",
};

export const TitleThirdStepContainer = {
  fontFamily: Fonts.sspBold,
  fontSize: 34,
  color: "white",
  marginBottom: "3vh",
  marginTop: 18,
};

export const activeImage = {
  backgroundSize: "cover",
  backgroundPosition: "center",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const activeContainer = {
  maxWidth: 300,
  marginTop: 20,
};

export const selectActiveTxt = {
  fontFamily: Fonts.sspBold,
  fontSize: 34,
  color: "white",
  margin: 0,
  marginTop: 25
};

export const selectOptionFormTxt = {
  fontFamily: Fonts.sspBold,
  fontSize: 34,
  color: "white",
  margin: 0,
  marginTop: 25,
  marginBottom:25
};

export const subtitleTxt = {
  fontFamily: Fonts.sspBold,
  fontSize: 20,
  color: "white",
  margin: 0,
};

export const contentTxt = {
  fontFamily: Fonts.sspLight,
  fontSize: 16,
  color: "white",
  margin: 5,
};

export const finalContentTxt = {
  fontFamily: Fonts.sspMedium,
  fontSize: 20,
  color: "white",
  margin: 5,
};

export const txtCard = {
  marginLeft: 12,
  fontFamily: Fonts.sspRegular,
  fontSize: 18,
  color: "white",
  marginBottom: 0,
};

export const AutorizeNIP = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const RecoverNIP = {
  fontFamily: Fonts.sspLight,
  fontSize: 16,
  color: Colors.yellow,
  cursor: "pointer",
  textDecoration: "underline",
  width: "fit-content",
  marginTop: 35,
  marginInline: "auto",
};

export const amountContainer = {
  marginTop: 30,
  marginBottom: 30,
};

export const amountInput = {
  width: 300,
  marginRight: 30,
};

export const InputDefault = {
  width: "100%",
  color: "white",
};

export const txtdefault = {
  marginLeft: 12,
  fontFamily: Fonts.sspRegular,
  fontSize: 12,
  color: "white",
  marginBottom: 0,
};

export const amountTxt = {
  fontFamily: Fonts.sspBold,
  fontSize: 16,
  color: "white",
  marginBottom: 30,
};

export const valueLabel = {
  color: "white",
  fontFamily: Fonts.sspMedium,
  fontSize: 12,
};

export const valueIcon = {
  color: "white",
  marginLeft: 5,
  fontSize: 13.5,
};

export const sliderStyle = {
  maxWidth: "90%",
  marginTop: 45,
  marginBottom: 20,
};

export const sliderHandle = {
  backgroundColor: Colors.yellow,
  borderColor: Colors.yellow,
  height: 20,
  width: 20,
};

export const sliderTrack = {
  backgroundColor: Colors.yellow,
  height: 10,
  borderRadius: 5,
};

export const checkboxGroup = {
  ...spaceEvenly,
  marginTop: 20,
};

export const checkboxFont = {
  fontSize: 12,
  fontFamily: Fonts.sspMedium,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

export const sixthStepContainer = {
  ...firstStepContainer,
  justifyContent: "center",
  alignItems: "center",
};

export const sixthStepTitle = {
  ...selectActiveTxt,
  marginBottom: 10,
  textAlign: "center" as "center",
};

export const sixthStepScrollbar = {
  height: "65vh",
  display: "flex" as "flex",
  flexDirection: "column" as "column",
  alignItems: "center" as "center",
  justifyContent: 'center',
};

export const sixthStepAuth = {
    marginTop: 30,
    display: "flex",
    justifyContent: "space-around",
    width: "40vw",
  };

export const sixthStepNip = { ...contentTxt, fontSize: 12, textDecoration: "underline" }